export const pageTitle = title => {
  return (document.title =
     'Hyper- Hypothermia Unit Menufacture and supllier | MercuryHC Pvt Ltd');
};
